var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    stroke: "white",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3919_33640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 8.00016C15.1666 4.31816 12.182 1.3335 8.49998 1.3335C4.81798 1.3335 1.83331 4.31816 1.83331 8.00016C1.83331 11.6822 4.81798 14.6668 8.49998 14.6668",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 1.36682C9.16663 1.36682 11.1666 4.00015 11.1666 8.00015",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83331 14.6335C7.83331 14.6335 5.83331 12.0002 5.83331 8.00015C5.83331 4.00015 7.83331 1.36682 7.83331 1.36682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2533 10.3335H8.49996",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2533 5.66687H14.7466",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.086 11.9448C15.4153 12.1475 15.3947 12.6401 15.056 12.6788L13.3447 12.8728L12.5773 14.4141C12.4253 14.7201 11.9553 14.5701 11.8773 14.1915L11.0407 10.1141C10.9747 9.79413 11.2627 9.5928 11.5407 9.76413L15.086 11.9448V11.9448Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/Web.ca56638e.svg";
export { ForwardRef as ReactComponent };